module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-fa7fe539.png";